/**
 * DiCon Incident Service API
 * API used by DiCon, LiOn and Buefo.
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: dienstleistung@netze-bw.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type Tag = 'MECHANIC' | 'ORDER_CENTER' | 'SUPPLIER' | 'COMMUNE' | 'MATERIAL_ORDER' | 'CABLE_DAMAGE' | 'TEMPORARY' | 'MAST_ACCIDENT' | 'TECHNICAL_SERVICE' | 'CONSTRUCTION_COORDINATION' | 'OPERATIONS_SERVICE' | 'EXTERNAL_SERVICE_PROVIDER' | 'SALES' | 'TECHNICAL_INSIDE_SALES' | 'INTERNAL_INSTALLER' | 'FOREMAN' | 'PROJECT_PLANNING' | 'DISPATCHING';

export const Tag = {
    Mechanic: 'MECHANIC' as Tag,
    OrderCenter: 'ORDER_CENTER' as Tag,
    Supplier: 'SUPPLIER' as Tag,
    Commune: 'COMMUNE' as Tag,
    MaterialOrder: 'MATERIAL_ORDER' as Tag,
    CableDamage: 'CABLE_DAMAGE' as Tag,
    Temporary: 'TEMPORARY' as Tag,
    MastAccident: 'MAST_ACCIDENT' as Tag,
    TechnicalService: 'TECHNICAL_SERVICE' as Tag,
    ConstructionCoordination: 'CONSTRUCTION_COORDINATION' as Tag,
    OperationsService: 'OPERATIONS_SERVICE' as Tag,
    ExternalServiceProvider: 'EXTERNAL_SERVICE_PROVIDER' as Tag,
    Sales: 'SALES' as Tag,
    TechnicalInsideSales: 'TECHNICAL_INSIDE_SALES' as Tag,
    InternalInstaller: 'INTERNAL_INSTALLER' as Tag,
    Foreman: 'FOREMAN' as Tag,
    ProjectPlanning: 'PROJECT_PLANNING' as Tag,
    Dispatching: 'DISPATCHING' as Tag
};

